import {
    LANGUAGE_UPDATE
} from './actionTypes'

export const setLanguage = language => ({
    type: LANGUAGE_UPDATE,
    payload: {
        language
    }
})




// WEBPACK FOOTER //
// ./src/redux/actions.js